import style from "./Project.module.css";
import React, { useEffect } from "react";
import { FaArrowRight, FaGithub } from "react-icons/fa";
import projImg2 from "../assets/img/revv.png";
import projImg3 from "../assets/img/indego.png";
import projImg4 from "../assets/img/expedia.png";
import { Col, Row } from "react-bootstrap";
import Aos from "aos";
import "aos/dist/aos.css";

export default function Project({ colorMode }) {
  useEffect(() => {
    Aos.init();
  }, []);
  return (
    <div >
      <div id="Projects" style={{ height: "100px" }}></div>
      <div id={style.projects}>
        <h1 style={{ padding: "20px", fontWeight: "bolder" }}>Projects</h1>

        <div id={style.Main}>
          <div className={style.projectDiv} data-aos="zoom-out-down">
            <div className={style.project_imgDiv} data-aos="fade-right">
              <img
                src="https://cdn.dorik.com/625f70b8180b790011866ddb/625f71b5180b790011866ddd/images/Screenshot-(61)_2nfbm0d7.png"
                alt="Myntra"
              />
            </div>

            <div
              className={style.project_detailsDiv}
              data-aos="fade-left"
              color={colorMode === "light" ? "#4C3575" : "#371B58"}
            >
              <h2
                className={style.project_detailsDiv_h2}
                size={["md", "md", "md", "lg"]}
              >
                Myntra Clone
              </h2>
              <h2
                className={style.project_detailsDiv_detail}
                fontWeight="500"
                size={["xs", "sm", "sm", "md"]}
              >
                Myntra is an Indian fashion e-commerce company for online
                shopping lifestyle products.
              </h2>
              <h2
                className={style.project_detailsDiv_tehcs}
                size={["sm", "sm", "sm", "md"]}
              >
                Tech Stack: HTML | CSS | JavaScript
              </h2>
              <div className={style.project_detailsDi_btnDiv}>
                <a
                  href="https://github.com/mahesh-jangid/Myntra-clone-project"
                  target="_blank"
                >
                  <button size={["xs", "sm", "sm", "md"]}>
                    <a className={style.links} rel="noreferrer">
                      Source Code{" "}
                    </a>{" "}
                    &nbsp;
                    <FaGithub />{" "}
                  </button>
                </a>
                <a
                  href="https://mahesh-jangid.github.io/Myntra-clone-project/"
                  target="_blank"
                >
                  <button size={["xs", "sm", "sm", "md"]}>
                    <a className={style.links} rel="noreferrer">
                      Live{" "}
                    </a>{" "}
                    &nbsp;
                    <FaArrowRight />{" "}
                  </button>
                </a>
              </div>
            </div>
          </div>

          <div
            className={style.projectDiv}
            data-aos="zoom-out-down"
            id={style.projectDivId}
          >
            <div className={style.project_imgDiv} data-aos="fade-right">
              <img src={projImg2} alt="revv" />
            </div>
            <div
              className={style.project_detailsDiv}
              data-aos="fade-left"
              color={colorMode === "light" ? "#4C3575" : "#371B58"}
            >
              <h2
                className={style.project_detailsDiv_h2}
                size={["md", "md", "md", "lg"]}
              >
                Revv Clone
              </h2>
              <h2
                className={style.project_detailsDiv_detail}
                fontWeight="500"
                size={["xs", "sm", "sm", "md"]}
              >
                Revv Cars is an Indian self-drive mobility startup. Car
                subscription from Revv provides the flexibility of having a car
                anytime you want
              </h2>
              <h2
                className={style.project_detailsDiv_tehcs}
                size={["sm", "sm", "sm", "md"]}
              >
                Tech Stack: HTML | CSS | JavaScript
              </h2>
              <div className={style.project_detailsDi_btnDiv}>
                <a
                  href="https://github.com/satyadav123/revvgroup-frontend"
                  target="_blank"
                >
                  <button size={["xs", "sm", "sm", "md"]}>
                    <a className={style.links} rel="noreferrer">
                      Source Code{" "}
                    </a>{" "}
                    &nbsp;
                    <FaGithub />{" "}
                  </button>
                </a>
                <a
                  href="https://revv-clone.netlify.app/index.html"
                  target="_blank"
                >
                  <button size={["xs", "sm", "sm", "md"]}>
                    <a className={style.links} rel="noreferrer">
                      Live{" "}
                    </a>{" "}
                    &nbsp;
                    <FaArrowRight />{" "}
                  </button>
                </a>
              </div>
            </div>
          </div>

          <div className={style.projectDiv} data-aos="zoom-out-down">
            <div className={style.project_imgDiv} data-aos="fade-right">
              <img src={projImg3} alt="Indiegogo" />
            </div>
            <div
              className={style.project_detailsDiv}
              data-aos="fade-left"
              color={colorMode === "light" ? "#4C3575" : "#371B58"}
            >
              <h2
                className={style.project_detailsDiv_h2}
                size={["md", "md", "md", "lg"]}
              >
                Indiegogo Clone
              </h2>
              <h2
                className={style.project_detailsDiv_detail}
                fontWeight="500"
                size={["xs", "sm", "sm", "md"]}
              >
                Indiegogo is your destination for innovations in tech, design &
                more, often with special perks and pricing for early adopters
              </h2>
              <h2
                className={style.project_detailsDiv_tehcs}
                size={["sm", "sm", "sm", "md"]}
              >
                Tech Stack: React | Redux | chakra-ui
              </h2>
              <div className={style.project_detailsDi_btnDiv}>
                <a
                  href="https://github.com/Surajbnp/Indiegogo-Clone"
                  target="_blank"
                >
                  <button size={["xs", "sm", "sm", "md"]}>
                    <a className={style.links} rel="noreferrer">
                      Source Code{" "}
                    </a>{" "}
                    &nbsp;
                    <FaGithub />{" "}
                  </button>
                </a>
                <a
                  href="https://63749cfcbfcf1b25a51bea10--indiegogoweb.netlify.app"
                  target="_blank"
                >
                  <button size={["xs", "sm", "sm", "md"]}>
                    <a className={style.links} rel="noreferrer">
                      Live{" "}
                    </a>{" "}
                    &nbsp;
                    <FaArrowRight />{" "}
                  </button>
                </a>
              </div>
            </div>
          </div>
          <div className={style.projectDiv} data-aos="zoom-out-down">
            <div className={style.project_imgDiv} data-aos="fade-right">
              <img src={projImg4} alt="Indiegogo" />
            </div>
            <div
              className={style.project_detailsDiv}
              data-aos="fade-left"
              color={colorMode === "light" ? "#4C3575" : "#371B58"}
            >
              <h2
                className={style.project_detailsDiv_h2}
                size={["md", "md", "md", "lg"]}
              >
                Expedia Clone
              </h2>
              <h2
                className={style.project_detailsDiv_detail}
                fontWeight="500"
                size={["xs", "sm", "sm", "md"]}
              >
                This project is a clone of Expedia.com which is a hotel, flights
                and cabs booking website
              </h2>
              <h2
                className={style.project_detailsDiv_tehcs}
                size={["sm", "sm", "sm", "md"]}
              >
                Tech Stack: React | Redux | chakra-ui
              </h2>
              <div className={style.project_detailsDi_btnDiv}>
                <a
                  href="https://github.com/Dhanraj4198/average-collar-3069"
                  target="_blank"
                >
                  <button size={["xs", "sm", "sm", "md"]}>
                    <a className={style.links} rel="noreferrer">
                      Source Code{" "}
                    </a>{" "}
                    &nbsp;
                    <FaGithub />{" "}
                  </button>
                </a>
                <a
                  href="https://expedia-clone-five.vercel.app/"
                  target="_blank"
                >
                  <button size={["xs", "sm", "sm", "md"]}>
                    <a className={style.links} rel="noreferrer">
                      Live{" "}
                    </a>{" "}
                    &nbsp;
                    <FaArrowRight />{" "}
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
